
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {t_page_meta} from '../../../../toolip/pub/types';
import {Button} from './../../../../shared/ui/button';
import styles from './404.module.less';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {perr_www_visit} from 'hola_pub_util';

export const Root = ()=>{
    const {theme} = useContext(Settings_context);
    useEffect(()=>{
        perr_www_visit({id: 'toolip_404_visit'});
    }, []);
    const {T, t} = use_translation_v({no_defaults: true});
    return <div className={styles.not_found_page}>
      <h3><T>Well this is awkward...</T></h3>
      <p className={theme.p2}>
        <T>The page you were trying to reach doesn't exist
          anymore, or maybe it has just moved. Feel free to contact us if the
          problem persists or if you can't find what you are looking for.</T>
      </p>
      <Button
        caption={t('Go to homepage')}
        to={'/'}/>
    </div>;
};

const meta: t_page_meta = {
    meta: {
        title: 'Page not found',
        description: 'Page not found | 404 Error',
        robots: 'noindex',
        canonical_url: 'https://browser.ai'
    },
    ssr_force: false,
    no_ssr: true,
    headless: false,
    footless: false,
    translation: {
        enabled: true,
        detect_by_country: true,
        white_list: ['en', 'ru', 'es', 'tr', 'de', 'fr', 'ja', 'he', 'zh']
    },
};

Root.meta = meta;
